import * as React from 'react';
import { Row as BaseRow } from '@mc/react-core';
import classNames from 'classnames';
import { useTheme } from '../useTheme';

type Props = React.ComponentProps<typeof BaseRow> & {};

export const Row: React.FC<Props> = ({ className, ...other }) => {
  const theme = useTheme();
  const cls = classNames(`${theme.ns}-row`, className, {});

  return <BaseRow className={cls} {...other} />;
};
